import { stepCounterGetters } from '@/store/modules/goalsStepCounter/routines'

export default {
  [stepCounterGetters.STEP_COUNTER_LIST]: state => state.stepCounterItems,
  [stepCounterGetters.ACTIVE_STEP_INDEX]: state => state.activeStepIndex
}
